import styled from "styled-components";

const Wrapper = styled.div`
  .userAvatar {
    opacity: ${props => (props.hover ? "0.5" : "1")};
  }

  .settingsSpin {
    minheight: 225px;

    div > div > span > div.ant-upload-list {
      .ant-upload-list-picture-container {
        .ant-upload-list-item {
          border: none;
          .ant-upload-list-item-info {
            .ant-upload-span {
              .ant-upload-list-item-card-actions {
                .ant-btn {
                  .anticon {
                    color: ${props => props.theme.color.red["red-6"]};
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .settings-header {
    > div > div > div {
      padding-right: 50px;
    }

    .metaOverlayDelete {
      width: 31px;
      height: 72px;
      position: absolute;
      z-index: 1;
      margin-top: -3px;
      margin-left: 0px;
      .anticon {
        position: absolute;
        top: 43%;
        left: 0%;
        width: 100%;
        height: 100%;
        color: transparent;
      }
      &:hover {
        .anticon {
          color: ${props => props.theme.color.blue["blue-7"]};
        }
      }
    }
    .metaOverlayEdit {
      width: ${props => (props.delete_active ? "31px" : "72px")};
      height: 72px;
      position: absolute;
      z-index: 1;
      margin-top: -3px;
      margin-left: 0px;
      left: ${props => (props.delete_active ? "31px" : "")};
      .anticon {
        position: absolute;
        top: 43%;
        left: ${props => (props.delete_active ? "31px" : "0%")};
        width: 100%;
        height: 100%;
        color: transparent;
      }
      &:hover {
        .anticon-edit {
          color: ${props => props.theme.color.blue["blue-7"]};
        }
      }
    }
  }

  .tabContainer {
    padding-top: 20px;
  }

  .osColumn {
    display: flex;
  }

  @media only screen and (max-width: 600px) {
    .ant-tabs-tab {
      font-size: 0.8em;
    }
    .ant-tabs-tabpane {
      padding-left: 10px;
    }
  }
  .ant-table-thead {
    .ant-table-cell {
      font-weight: ${props => props.theme.text.bold};
      padding-top: 0.5em;
      padding-bottom: 0.5em;
    }
  }
`;

export default Wrapper;
